<div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">

        <form [formGroup]="form" (submit)="shareReport()" (keydown.enter)="shareReport()" method="POST">

          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-4">
            <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#f8edff] sm:mx-0 sm:h-10 sm:w-10">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-[#802cfa]">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Share Report</h3>
              <div class="mt-2">

                <p class="text-sm text-gray-500 mb-3">
                  Easily share your report by entering email address and clicking Share.
                  Once shared, recipients can immediately find the report in their list, facilitating quick access and seamless collaboration.
                </p>

                <div class="sm:col-span-4">
                  <fieldset [disabled]="loading$ | async">
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
                    <div class="mt-2">
                      <input type="email" id="email" formControlName="email" autocomplete="email" required placeholder="Enter recipient's email address" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#802cfa] sm:text-sm sm:leading-6">
                    </div>

                    <div class="pt-1" *ngIf="form.get('email').touched && form.get('email').invalid">
                      <div class="ng-invalid text-xs text-red-500" *ngIf="form.get('email').errors?.['required']">
                        Email is required.
                      </div>
                      <div class="ng-invalid text-xs text-red-500" *ngIf="form.get('email').errors?.['email']">
                        Value must be an email
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div class="sm:col-span-4 mt-4">
                  <fieldset [disabled]="loading$ | async">
                    <label for="message" class="block text-sm font-medium leading-6 text-gray-900">Message (optional)</label>
                    <div class="mt-2">
                      <textarea id="message" formControlName="message" rows="3" placeholder="Add an optional message to include with the shared report" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#802cfa] sm:text-sm sm:leading-6 resize-none"></textarea>
                    </div>
                  </fieldset>
                </div>

              </div>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="submit" [disabled]="loading$ | async" class="inline-flex w-full justify-center rounded-md bg-[#802cfa] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 sm:ml-3 sm:w-auto">Share</button>
            <button type="button" [disabled]="loading$ | async" (click)="closeModal()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
